<template>
  <div class="content">
    <card>
      <h4 slot="header" class="card-title">Perfil</h4>
      <form action="" class="modal-body">
        <div class="row">
          <div class="col-lg-2 img-container align-self-center mr-4">
            <img
              :src="usuario.imagem"
              alt="Foto do perfil"
              id="profile-photo"
            />
          </div>
          <div class="col-lg-9">
            <div class="row">
              <base-input
                v-if="usuario.tipoParceiro === 'pf'"
                type="text"
                label="Nome"
                v-model="usuario.nome"
                disabled="true"
                class="col-lg-6"
              ></base-input>
              <base-input
                v-if="usuario.tipoParceiro === 'pf'"
                type="text"
                label="Sobrenome"
                v-model="usuario.sobrenome"
                disabled="true"
                class="col-lg-6"
              ></base-input>
              <base-input
                v-if="usuario.tipoParceiro === 'pj'"
                type="text"
                label="Razão Social"
                v-model="usuario.razaoSocial"
                disabled="true"
                class="col-lg-12"
              ></base-input>
              <base-input
                type="text"
                label="Tipo de Usuário"
                v-model="tipoParceiroToString"
                disabled="true"
                class="col-lg-6"
              ></base-input>
              <base-input
                type="text"
                label="Perfil"
                v-model="tipoUsuarioToString"
                disabled="true"
                class="col-lg-6"
              ></base-input>
            </div>
          </div>
          <base-input
            type="text"
            label="CEP"
            v-model="cepFormatted"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="text"
            label="Cidade"
            v-model="usuario.cidade"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="text"
            label="Estado"
            v-model="usuario.estado"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="text"
            label="Bairro"
            v-model="usuario.bairro"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="text"
            label="Logradouro"
            v-model="usuario.rua"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="text"
            label="Número"
            v-model="usuario.numero"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="text"
            label="Telefone"
            v-model="telefoneFormatted"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="text"
            label="Email"
            v-model="usuario.email"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            v-if="usuario.tipoParceiro === 'pf'"
            type="text"
            label="CPF"
            v-model="cpfFormatted"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            v-if="usuario.tipoParceiro === 'pj'"
            type="text"
            label="CNPJ"
            v-model="cnpjFormatted"
            disabled="true"
            class="col-lg-4"
          ></base-input>
          <base-input
            v-if="usuario.tipoParceiro === 'pj'"
            type="text"
            label="Pessoa para contato"
            v-model="usuario.pessoaContato"
            disabled="true"
            class="col-lg-4"
          ></base-input>
        </div>
      </form>
    </card>
    <card>
      <h4 slot="header" class="card-title">Atualizar senha</h4>
      <form action="" class="modal-body">
        <div class="row">
          <base-input
            type="password"
            label="Senha atual"
            v-model="senhaAtual"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="password"
            label="Nova senha"
            v-model="novaSenha"
            class="col-lg-4"
          ></base-input>
          <base-input
            type="password"
            label="Confirmação nova senha"
            v-model="confirmacaoNovaSenha"
            class="col-lg-4"
          ></base-input>
        </div>
        <div class="float-right">
          <button
            :disabled="
              senhaAtual === '' ||
                novaSenha === '' ||
                novaSenha.length < 6 ||
                novaSenha !== confirmacaoNovaSenha
            "
            class="btn btn-success btn-fill"
            @click.prevent
            @click="alterarSenha()"
          >
            Atualizar
          </button>
        </div>
      </form>
    </card>
  </div>
</template>
<script>
import _ from 'lodash';
import Card from 'src/components/Cards/Card.vue';
import UserServices from 'src/services/usuarios';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  data() {
    return {
      usuario: {},
      tipoParceiroToString: '',
      tipoUsuarioToString: '',
      senhaAtual: '',
      novaSenha: '',
      confirmacaoNovaSenha: ''
    };
  },
  created() {
    this.usuario = this.$store.state.usuario;

    if (_.has(this, 'usuario.cpf')) {
      this.cpfFormatted = this.formatCpf(this.usuario.cpf);
    }
    if (_.has(this, 'usuario.cnpj')) {
      this.cnpjFormatted = this.formatCnpj(this.usuario.cnpj);
    }
    this.cepFormatted = this.formatCep(_.get(this, 'usuario.cep'));
    this.telefoneFormatted = this.formatPhone(_.get(this, 'usuario.telefone'));
    this.tipoParceiroToString =
      _.get(this, 'usuario.tipoParceiro') === 'pf'
        ? 'Pessoa Física'
        : 'Pessoa Jurídica';
    this.tipoUsuarioToString = _.capitalize(_.get(this, 'usuario.tipoUsuario'));
  },
  methods: {
    formatPhone(tel) {
      tel = tel.replace(/\D/g, '');
      tel = tel.replace(/^(\d)/, '($1');
      tel = tel.replace(/(.{3})(\d)/, '$1)$2');
      if (tel.length == 9) {
        tel = tel.replace(/(.{1})$/, '-$1');
      } else if (tel.length == 10) {
        tel = tel.replace(/(.{2})$/, '-$1');
      } else if (tel.length == 11) {
        tel = tel.replace(/(.{3})$/, '-$1');
      } else if (tel.length == 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      } else if (tel.length > 12) {
        tel = tel.replace(/(.{4})$/, '-$1');
      }
      return tel;
    },
    formatCep(cep) {
      cep = cep.replace(/\D/g, '');
      cep = cep.replace(/^(\d{2})(\d)/, '$1.$2');
      cep = cep.replace(/\.(\d{3})(\d)/, '.$1-$2');
      return cep;
    },
    formatCpf(cpf) {
      cpf = cpf.replace(/\D/g, '');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
      cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
      return cpf;
    },
    formatCnpj(cnpj) {
      cnpj = cnpj.replace(/\D/g, '');
      cnpj = cnpj.replace(/^(\d{2})(\d)/, '$1.$2');
      cnpj = cnpj.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
      cnpj = cnpj.replace(/\.(\d{3})(\d)/, '.$1/$2');
      cnpj = cnpj.replace(/(\d{4})(\d)/, '$1-$2');
      return cnpj;
    },
    alterarSenha() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Senha atualizada com sucesso',
          'fa fa-check'
        );
        this.senhaAtual = '';
        this.novaSenha = '';
        this.confirmacaoNovaSenha = '';

        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };
      UserServices.atualizarSenha({
        senhaAtual: this.senhaAtual,
        novaSenha: this.novaSenha,
        userId: this.usuario._id
      })
        .then(sucessCallback)
        .catch(errorCallback);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    }
  }
};
</script>
<style>
#profile-photo {
  min-width: 10em;
  width: 15em;
}
.img-container {
  text-align: center;
  justify-items: center;
}
@media (min-width: 992px) {
  .card form [class*='col-']:last-child {
    padding-right: 6px;
  }
  .card form [class*='col-']:first-child {
    padding-left: 6px;
  }
}
</style>
